"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "תוך כמה זמן ניתן להשיג מטפל סיעודי?",
  answer: "אנו מתחייבים למציאת פתרון מהיר ומקצועי, לעיתים תוך 5 שעות בלבד בערים מרכזיות. הצוות שלנו ערוך למקרי חירום ומעניק מענה מיידי לצרכי המטופל בכל שעה."
}, {
  question: "האם המטפלים שלכם עוברים הסמכה מקצועית?",
  answer: "בהחלט. כל המטפלים והמטפלות בצוות שלנו עוברים תהליך סינון קפדני הכולל ראיונות עומק, בדיקת המלצות, הכשרות מקצועיות שוטפות ובדיקות רקע מקיפות כדי להבטיח טיפול בטוח ומסור."
}, {
  question: "אילו סוגי שירותים אתם מציעים?",
  answer: "אנו מציעים מעטפת רחבה של שירותי סיעוד: החל מהשגחה בבית חולים לאחר ניתוח, דרך ליווי סיעודי ארוך טווח בבית המטופל, ועד סיוע בפעולות יומיומיות, רחצה וניהול משק בית."
}, {
  question: "האם ניתן לקבל החזרים מחברות הביטוח או מקופות החולים?",
  answer: "כן, השירותים שלנו מוכרים על ידי רוב חברות הביטוח הפרטיות (במסגרת פוליסות סיעוד) וקופות החולים. אנו מסייעים בהנפקת כל המסמכים והקבלות הנדרשים לצורך קבלת החזר כספי מרבי."
}, {
  question: "מה קורה אם אין התאמה בין המטפל למטופל?",
  answer: "החיבור האישי הוא המפתח להצלחת הטיפול. במידה ואין התאמה מכל סיבה שהיא, אנו דואגים להחלפה מהירה במטפל אחר שיתאים טוב יותר לצרכים הייחודיים ולאופיו של המטופל."
}, {
  question: "האם השירות זמין גם בסופי שבוע וחגים?",
  answer: "מוקד השירות שלנו זמין 24/7. אנו מבינים שצרכי סיעוד יכולים להתעורר בכל רגע, ולכן אנו מספקים מענה מלא גם בשבתות, חגים ובשעות הלילה המאוחרות ללא הפסקה."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="25062" id="frequently-asked-questions" className="bg-background text-foreground py-24 px-6 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-[10%] left-[10%] w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[10%] right-[10%] w-96 h-96 bg-accent/5 rounded-full blur-3xl" />
      </div>

      <div ref={ref} className={cn("relative z-10 max-w-3xl mx-auto transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground font-default">
            שאלות נפוצות
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto font-default">
            כל המידע שחשוב לדעת על שירותי הסיעוד המקצועיים שלנו, הזמינות המיידית והליווי האישי למשפחה.
          </p>
        </div>

        <div className="bg-card/30 backdrop-blur-sm border border-border/50 rounded-2xl p-6 md:p-8 shadow-sm">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-border/40 last:border-0" data-index={i}>
                <AccordionTrigger className="text-left text-base md:text-lg font-medium hover:text-primary transition-colors py-5 font-default">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 font-default">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-6 font-default">
            עדיין יש לכם שאלות? הצוות המקצועי שלנו כאן כדי לעזור.
          </p>
          <Button asChild size="lg" className="rounded-full px-8 bg-primary text-primary-foreground hover:bg-primary/90 font-default">
            <Link to="/ContactPage">דברו איתנו עכשיו</Link>
          </Button>
        </div>
      </div>
    </section>;
}